module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "navbar navbar-default navbar-fixed-top",
    on: {
      "click": _vm.gotoErr
    }
  }, [_c('div', [_c('div', {
    staticClass: "navbar-header logo"
  }, [_c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.can("god4all.admin.user.client.client-admin.any")),
      expression: "can(\"god4all.admin.user.client.client-admin.any\")"
    }],
    staticClass: "navbar-brand",
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/logo/AlarmBot_Logo-outline.svg",
      "title": _vm.getTranslation('app_title')
    },
    on: {
      "click": function($event) {
        _vm.closeAlertWarning()
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('banet-clock', {
    staticClass: "headerClock"
  }), _vm._v(" "), _c('div', {
    staticClass: "collapse navbar-collapse pull-right"
  }, [_c('ul', {
    staticClass: "nav navbar-nav navbar-right"
  }, [_c('li', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.dropClose),
      expression: "dropClose"
    }],
    staticClass: "dropdown",
    class: {
      open: _vm.isOpened
    }
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown",
      "role": "button",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.dropToggle($event)
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-user-circle-o"
  }), _vm._v("  \n                            " + _vm._s(_vm.loggedUser.firstName) + " " + _vm._s(_vm.loggedUser.lastName) + "\n                            "), _c('span', {
    staticClass: "glyphicon glyphicon-menu-hamburger",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    on: {
      "click": _vm.dropToggle
    }
  }, [_c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.can("god4all.admin")),
      expression: "can(\"god4all.admin\")"
    }],
    attrs: {
      "to": "/clients",
      "activeClass": "active",
      "tag": "li"
    }
  }, [_c('a', [_c('span', {
    staticClass: "fa fa-address-book-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.getTranslation('menu_main_client_list')))])])]), _vm._v(" "), _c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.can("god4all.admin")),
      expression: "can(\"god4all.admin\")"
    }],
    attrs: {
      "to": "/users",
      "activeClass": "active",
      "tag": "li"
    }
  }, [_c('a', [_c('span', {
    staticClass: "fa fa-users",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        _vm.closeAlertWarning()
      }
    }
  }, [_vm._v(_vm._s(_vm.getTranslation('menu_main_user_list')))])])]), _vm._v(" "), _c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.can("god4all.admin")),
      expression: "can(\"god4all.admin\")"
    }],
    attrs: {
      "to": "/translations",
      "activeClass": "active",
      "tag": "li"
    }
  }, [_c('a', [_c('span', {
    staticClass: "glyphicon glyphicon-text-size",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        _vm.closeAlertWarning()
      }
    }
  }, [_vm._v(_vm._s(_vm.getTranslation('menu_main_translation_list')))])])]), _vm._v(" "), _c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.can("god4all.admin")),
      expression: "can(\"god4all.admin\")"
    }],
    attrs: {
      "to": "/history",
      "activeClass": "active",
      "tag": "li"
    }
  }, [_c('a', [_c('span', {
    staticClass: "glyphicon glyphicon-time",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        _vm.closeAlertWarning()
      }
    }
  }, [_vm._v(_vm._s(_vm.getTranslation('menu_main_history')))])])]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.can("god4all.admin")),
      expression: "can(\"god4all.admin\")"
    }],
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }), _vm._v(" "), (_vm.isLogged) ? _c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.can("god4all.admin.user.client.client-admin")),
      expression: "can(\"god4all.admin.user.client.client-admin\")"
    }],
    attrs: {
      "to": "/myprofile",
      "activeClass": "active",
      "tag": "li"
    }
  }, [_c('a', [_c('span', {
    staticClass: "glyphicon glyphicon-user",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        _vm.closeAlertWarning()
      }
    }
  }, [_vm._v("\n                                    " + _vm._s(_vm.getTranslation('menu_main_my_profile')) + " ")])])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.logout($event)
      }
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.closeAlertWarning()
      }
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-log-out",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.getTranslation('app_lbl_action_logout')) + " ")])])], 1)])])])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6fea9f92!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App/public/components/layout/Header.vue
// module id = 690
// module chunks = 0